import type { GrowthBookSchema } from '@doxyme/config';
import { useGrowthBookFlag } from '../useGrowthBookFlag/useGrowthBookFlag';
import { useIsVirtualBackgroundEnabled } from './useIsVirtualBackgroundEnabled';

export const BRANDED_VIRTUAL_BACKGROUND_FEATURE_FLAG: keyof GrowthBookSchema =
  'feat_prod_1303_branded_virtual_background';

export const useIsBrandedVirtualBackgroundEnabled = () => {
  const isVirtualBackgroundEnabled = useIsVirtualBackgroundEnabled();
  const isFlagEnabled =
    useGrowthBookFlag(BRANDED_VIRTUAL_BACKGROUND_FEATURE_FLAG) === true;

  return isVirtualBackgroundEnabled && isFlagEnabled;
};
